import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';

export default function SideDrawer({ isOpen = true, handleClose = () => {}, children = <></> }) {
  return (
    <div>
      <React.Fragment key={'right'}>
        <Drawer
          anchor={'right'}
          open={isOpen}
          onClose={handleClose}
          sx={{
            '& .MuiDrawer-paper': {
              width: '500px',
              boxSizing: 'border-box',
              height: '95vh',
              maxWidth: '50%',
              top: '2.5vh'
            }
          }}>
          {children}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
